import { UseMutationOptions } from "@tanstack/react-query";
import { ClientError } from "graphql-request";

import { graphql } from "lib/generated/app-service-gql";
import {
  DocumentFindLeadsForTermMutation,
  DocumentFindLeadsForTermMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";

export const DOCUMENT_FIND_LEADS_TERM_MAX_LENGTH = 500;

// Admin-only. The result is never cached server-side, so it lives only in this mutation's state.
const documentFindLeadsForTermMutation = graphql(`
  mutation documentFindLeadsForTerm($documentId: String!, $term: String!) {
    documentFindLeadsForTerm(documentId: $documentId, term: $term) {
      documentId
      documentName
      buyerName
      buyerId
      leads {
        leadTitle
        leadMotivation
        matchingText
        leadType
        pageNumbers
        createdLeadId
        chunkNumber
        locations {
          pageNumber
          bbox {
            x
            y
            width
            height
          }
        }
      }
    }
  }
`);

export function useDocumentFindLeadsForTerm(
  options?: UseMutationOptions<
    DocumentFindLeadsForTermMutation,
    ClientError,
    DocumentFindLeadsForTermMutationVariables,
    unknown
  >,
) {
  return useGraphQlMutation(documentFindLeadsForTermMutation, options);
}
